import './Calisthenics.css';
import {Link} from 'react-router-dom'
import React from "react";
import Footer from '../Footer';

function Calisthenics(props) {

    return (
        <div className="type">
            <Link className="link" to="/" >
                <p className="backButton"> back to home </p>
            </Link>
                <h1 className="calHeaderTextUpper"> Creative  </h1>
                <h2 className="calHeaderTextLower">  Calisthenics </h2>
                <p className="storyBodyText">
                In a world where AI can "generate" (read: copy and regurgitate) anything with a click of a button, your individual creativity is more important than ever. Creative Calisthenics is an interactive program designed to boost your imagination and spark collaboration. We have options for everyone, even those with absolutely no art or design experience.
                </p>

                                <p className="storyBodyText">
                more details and sign up coming soon!
                </p>
            <Footer/>
        </div>

    )

}

export default Calisthenics;